
<td> SLOT {{ slotNumber }} </td>

<td> {{ measurementData.refreshrate   }}  sec <B> {{ status}}</B> </td>
<td> {{ measurementData.channelfull}} </td>
<td> Full channel : {{ measurementData.channelfull}} </td>

<td> Channel: {{ measurementDescription.channelnr}}{{ measurementDescription.channela}} </td>
<td> Description: {{ GetDescription() }} </td>


<td> Department:    {{ GetDepartment() }} </td>
<td> Value Raw:    {{ measurementData.rawvalue }} </td>
<td> Value :    {{ measurementData.measurementvalue }} </td>


<!--<mat-card class="measurement-card">-->
<!--  <mat-card-header>-->
<!--&lt;!&ndash;    <div mat-card-avatar class="measurement-header-image">&ndash;&gt;-->
<!--&lt;!&ndash;      <mat-icon aria-hidden="false" aria-label="home icon">multiline_chart</mat-icon>&ndash;&gt;-->
<!--&lt;!&ndash;    </div>&ndash;&gt;-->
<!--&lt;!&ndash;    <mat-card-title>{{ measurementDescription.description   }} <br/> channel <B>{{ measurementDescription.channelfull }}</B>   ( <small> {{ oldStyleChannel }}  </small>  )    </mat-card-title>&ndash;&gt;-->
<!--&lt;!&ndash;    <mat-card-subtitle> Department:    {{ measurementDescription.department   }} Refnr *not there*    </mat-card-subtitle>&ndash;&gt;-->
<!--&lt;!&ndash;    <mat-card-subtitle> Fullchannel: {{ fullChannelNumber}}   </mat-card-subtitle>&ndash;&gt;-->

<!--      <mat-grid-tile style="background: cornsilk" colspan="8" rowspan="6">-->
<!--        <mat-grid-tile-header>-->
<!--          Data as used in IO-Mapper  {{ ((fullChannelNumber-measurementData.number)==0) ? "" : "refnumber and id not match"   }}-->
<!--        </mat-grid-tile-header>-->
<!--        <mat-list>-->
<!--          <mat-list-item >-->
<!--            <kendo-textbox [readonly]="true" [value]="GetValue()">-->
<!--              <ng-template kendoTextBoxSuffixTemplate>-->
<!--                <kendo-textbox-separator></kendo-textbox-separator>-->
<!--                  {{ measurementData.measurementunit   }}-->
<!--              </ng-template>-->

<!--            </kendo-textbox>-->
<!--          </mat-list-item >-->



<!--          <mat-list-item >-->
<!--            <div mat-line>  Timestamp:  {{ measurementData.timestamp   }}  </div>-->
<!--          </mat-list-item>-->

<!--          <mat-list-item >-->
<!--            <div mat-line>  Access: {{ measurementData.measurementaccess}} </div>-->
<!--          </mat-list-item>-->

<!--          <mat-list-item >-->
<!--            <div mat-line>  ADC: In 0x{{ measurementData.tmsc_input.toString(16).toUpperCase()}} Para 0x{{ measurementData.tmsc_parameter.toString(16).toUpperCase()}}     </div>-->
<!--          </mat-list-item>-->

<!--          <mat-list-item >-->
<!--            <div mat-line>  RAWValue : {{ measurementData.rawvalue}} </div>-->
<!--          </mat-list-item>-->

<!--          <mat-list-item >-->
<!--            <div mat-line>  Full channel : {{ measurementData.channelfull}} </div>-->
<!--          </mat-list-item>-->

<!--          <mat-list-item >-->
<!--            <div mat-line>  Owner : {{ measurementData.owner}} </div>-->
<!--          </mat-list-item>-->

<!--          <mat-list-item >-->
<!--            <div mat-line>  Department : {{ measurementData.department_name}}, Ref:  {{ measurementData.department }} </div>-->
<!--          </mat-list-item>-->




